import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';
// import { environment } from 'src/environment';
import { environment } from 'src/environments/environment';

import { GridDataService } from '../../base-data-services/grid-data.service';
import { CompanyMentorModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-data.model';
import { CompanyMentorListingModel, CompanyMentorGridParams } from 'common/models/page-models/internship-company/company-mentor/company-mentor-grid.model';


@Injectable({
  providedIn: 'root',
})
export class CompanyMentorGridDataService extends GridDataService<
  CompanyMentorListingModel,
  CompanyMentorModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.internshipCompanyMentor, http, ss);
  }

  createInstance(): CompanyMentorListingModel {
    return new CompanyMentorListingModel();
  }

  override getGridParams(param): GridPostParams {
    const params = new CompanyMentorGridParams();
    params.internshipCompanyId = param.id ? param.id : param.internshipCompanyId;
    return params;
  }

  override getDeleteUrl() {
    return environment.apiUrl + API_URL.internshipCompanyMentorDelete;
  }

//   override getDeletePayload(data){
    
//     let payload;
//     if(data.id){
//         payload={id:[data.id]}
//     }
//     else{
//         payload=data;
//     }
    
//     return payload;
// }


override getDeletePayload(data) {
  let payload;

  if (data.id) {
      // Check if `data.id` is a string with comma-separated values
      if (typeof data.id === 'string') {
          // Split the string by commas and convert to an array of numbers
          payload = { id: data.id.split(',').map(id => parseInt(id.trim(), 10)) };
      } else {
          // If `data.id` is already an array of IDs, just assign it
          payload = { id: Array.isArray(data.id) ? data.id : [data.id] };
      }
  } else {
      // If `data.id` doesn't exist, return the original data
      payload = data;
  }

  return payload;
}

}
